module.exports = __webpack_public_path__ + "img/56-daece4.png";